<template>
  <v-row dense>
    <v-col cols="12">
      <v-autocomplete
        v-model="form.device_id"
        name="device_id"
        item-text="inline"
        item-value="id"
        :items="devices"
        :readonly="readonly"
        :label="`${$t('DEVICES.ITEM')} *`"
        :rules="getRulesByName('device_id')"
        :error-messages="errors.device_id"
        clearable
        cache-items
        @change="updateValue('device_id', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import { notEmpty } from '@/modules/_global/variables/rules';
import { WarehouseDevicesService } from '@/services/warehouse-devices.service';

export default {
  name: 'AttachForm',

  mixins: [formEditable],

  data() {
    return {
      form: {
        device_id: null
      },
      devices: [],
      rules: {
        device_id: [notEmpty]
      }
    };
  },

  computed: {
    device() {
      if (!this.form.device_id) {
        return null;
      }

      return this.devices.find(device => device.id === this.form.device_id);
    }
  },

  watch: {
    device() {
      this.$emit('selected-device', this.device);
    }
  },

  mounted() {
    WarehouseDevicesService.getFilteredList({}).then(({ data }) => {
      this.devices = data.data;
    });
  }
};
</script>
